<template>
  <v-container v-if="isFilterEnabled" fluid class="py-0" style="height: 100%;">
    <v-row align="center" justify="space-between">
      <v-col cols="10" md="4">
        <v-btn @click="exportFile" color="primary" outlined><v-icon left>mdi-download-outline</v-icon>Export</v-btn>
        <v-chip
            v-if="grid.selectedRows.length > 0"
            class="ml-3"
            color="primary"
            close
            pill
            @click:close="cancelSelection"
        >
          <v-avatar left class="primary darken-3">{{grid.selectedRows.length}}</v-avatar>
          {{`${grid.selectedRows.length > 1 ? 'Rows' : 'Row'} selected`}}
        </v-chip>
      </v-col>

      <v-col cols="4" class="text-center hidden-sm-and-down">
        <Title></Title>
      </v-col>

      <v-col cols="2" md="4">
        <v-row justify="end" class="pr-3">
          <v-btn to="/" color="primary" fab small>
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <Grid></Grid>

  </v-container>

  <v-container v-else>
    <v-row justify="center">
      <Logo></Logo>
    </v-row>
    <v-row justify="center">
      <v-col cols="4" align="center">
        <div class="title mb-4">Please enter a valid species and gene name or sequence...</div>
        <v-btn to="/" class="mx-auto" color="primary" fab x-large>
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import Grid from '../components/Grid';
  import Logo from '../components/Logo';
  import Title from '../components/Title';

  export default {
    name: 'Result',
    components: {
      Grid,
      Logo,
      Title
    },
    data() {
      return {
      }
    },
    computed: {
      ...mapState([
        'grid'
      ]),
      ...mapGetters([
        'isFilterEnabled'
      ])
    },
    mounted() {
      if (this.grid.selectedRows.length > 0) {
        this.cancelSelection();
      }
    },
    methods: {
      ...mapActions([
        'addNotification',
        'updateSelectedRows'
      ]),
      exportFile() {
        this.grid.api.exportDataAsCsv({
          allColumns: true,
          rowDeselection: true,
          onlySelected: this.grid.selectedRows.length > 0,
          processCellCallback: params => {
            if(params.column.colId === 'autoPick') {
              return params.value === 99 ? null : params.value
            }
            return params.value;
          }
        });
      },
      cancelSelection() {
        this.grid.api.deselectAll();
        this.updateSelectedRows([]);
      }
    }
  }
</script>
